import { render, staticRenderFns } from "./RegistryFooter.vue?vue&type=template&id=3b901182&"
import script from "./RegistryFooter.vue?vue&type=script&lang=js&"
export * from "./RegistryFooter.vue?vue&type=script&lang=js&"
import style0 from "./RegistryFooter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports